import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ValidationConstants } from '@app/core/_constant/validation.constants';

@Component({
  selector: 'control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss'],
})
export class ControlMessagesComponent implements OnInit {
  @Input() control :UntypedFormControl;
  @Input() controlName :string;
  @Input() submitted :boolean;
  @Input() minlength :number;
  @Input() maxlength :number;
  @Input() errorType :string;

  passMaxLength :number = ValidationConstants.password.max;

  constructor() {}

  ngOnInit() {}
}
